/**
 * @ngdoc directive
 * @name cbl.finanza.mf.directive:finanzaSaldoDossier
 * @restrict E
 * @scope
 * @description Componente rappresentante il dettaglio del saldo dossier
 * @param {String} sceltaDossierState - Nome dello stato per la scelta del dossier
 * @param {String} visualizzaRaccomandazioneState - Nome dello stato per andare nella sezione di visualizzazione di una raccomandazione
 * @param {String} modificaRaccomandazioneState - Nome dello stato per andare nella sezione di modifica di una raccomandazione
 * @param {String} nuovaRaccomandazioneState - Nome dello stato per andare nella sezione di creazione di una raccomandazione
 * @param {String} rifiutaRaccomandazioneState - Nome dello stato in cui navigare dopo aver rifiutato una raccomandazione
 * @param {String} accettaRaccomandazioneState - Nome dello stato in cui navigare dopo aver accettato una raccomandazione
 * @param {String} sceltaDossierState - Nome dello stato in cui è contenuta la lista dei dossiers
 */
(function () {
  'use strict';
  var EstrattoContoCtrl = function (
    $http,
    $scope,
    $window,
    $q,
    $stateParams,
    $state,
    $location,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    uiGridConstants,
    messaggiSrvc,
    userSrvc,
    $uibModal,
    brioSrvc,
    service,
    tableService,
    deskSrvc,
    EstrattoContoSrvc,
    FinUploadSrvc
  ) {
    var self = this;
    this.$uibModal = $uibModal;
    this.$http = $http;
    this.$window = $window;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$location = $location;
    this.messaggiFctr = messaggiFctr;
    this.messaggiSrvc = messaggiSrvc;
    this.userSrvc = userSrvc;
    this.brioSrvc = brioSrvc;
    this.deskSrvc = deskSrvc;
    this.tableService = tableService;
    this.posizione = {};
    this.ndgs = [];
    this.selectNdg = [];
    this.selectRapporti = [];
    this.CONSTANTS = CONSTANTS;
    this.startDate = new Date();
    this.endDate = new Date();
    this.minDate = new Date();
    this.dataTable = null;
    this.gridTable = {};
    this.avvertenze = [];
    this.filterBox = {
      totaleScadenza: true,
      cedole: true,
      rimborsi: true,
      dividendi: true,
      strumentiUS: false
    };
    this.totaliConti = {};
    this.endDate.setFullYear(this.endDate.getFullYear() + 1);
    $scope.service = EstrattoContoSrvc;
    $scope.msg = labelSrvc.getLabel;
    $scope.estrattoContoFiscale={};
    $scope.minusvalenzeAccantonate={};
    $scope.FinUploadSrvc = FinUploadSrvc;
    $scope.plusMinusperModale = {};
    $scope.tabellaEstrattoConto = {}
    this.messaggiFctr.chiudiLoaderBrio();
    $scope.spinner = {
      reportMinus: false,
      exportXls: false
    };
    $scope.service.filtriEstrattoContoFiscale = {
        salIniz:true,
        salFin:true,
        plusMinus:true,
        venditaScaricoPrelievo:false,
        acquistoCaricoConf:false,
        espandiTutto: true
    }
    //IMPOSTO LA START DATE AL PRIMO GENNAIO DI QUESTO ANNO MENO 5 ANNI
    this.setStartDate = function(){
      var today = new Date();
      var thisYearFirstDay = today.getFullYear()-5+'-01-01';
      return thisYearFirstDay;
    }
    this.setEndDate = function(){
      var today = new Date();
      var thisYearLastDay = today.getFullYear()+'-12-31';
      return thisYearLastDay;
    }
    this.startDate=self.setStartDate();
    this.endDate = self.setEndDate();
    this.maxDate = new Date('2099-12-31');
    this.dataMinima = new Date(self.setStartDate());
    $scope.service.inputFormMovimenti = {
      dataInizio: new Date(self.startDate),
      dataFine: new Date(self.endDate),
    }
    $scope.numeroRapporto = $stateParams.finCodiceRapporto;
    this.collapseState =[];
    this.isStateCorrect = true; 
    var self = this;

    /*
     * ----------------------------
     * START METODI INIT CONTROLLER
     * ----------------------------
     */
    service
      .promiseCustomerData($stateParams.finCodiceRapporto)
      .then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.posizione = {};
            return;
          }
          self.posizione = response.data;
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
        }
      )
      .finally(function () {
        self.spinner.customerData = false;
      });

    service
      .promiseFilterNdg($stateParams.finCodiceRapporto)
      .then(function (response) {
        if (self.messaggiFctr.processaResponse(response)) {
          return;
        }
        self.ndgs = response.data.result;
        self.selectNdg = [];
        self.ndgs.forEach(function (ndg) {
          self.selectNdg.push({
            ndg: ndg.ndg,
            intestazione: ndg.intestazione,
            selected: true
          });
        });
        self.reloadRapporti();
      })
      .finally(function () {
        self.spinner.filterNdg = false;
      });

      service.promiseTotaliConti($stateParams.finCodiceRapporto)
      .then(function(response){
        if(self.messaggiFctr.processaResponse(response)){
          return;
        }else{
          self.totaliConti=response.data.result;
        }
      })
    // Chiamo il getDossier per inserire le info nel customerdata

    labelSrvc.labelsPronte.then(function () {
      if (self.deskSrvc.isDesk) {
        self.deskSrvc.aggiungiEntry(
          labelSrvc.getLabel('dossier.cashflow.titolo')
        );
      }

      for (var label in labelSrvc.labels) {
        if (label.startsWith('cashflow.avvertenze.'))
          self.avvertenze.push(labelSrvc.getLabel(label));
      }
    });
    /* this.service.inputFormMovimenti.startDate = new Date();
    this.service.inputFormMovimenti.endDate = new Date(); */
    /*
     * --------------------------
     * END METODI INIT CONTROLLER
     * --------------------------
     */

    this.filterCashFlow = function () {
      self.spinner.cashflow = true;
      var rapporti = [];
      self.selectRapporti.forEach(function (rapp) {
        if (rapp.selected) {
          rapporti.push(rapp.rapporto);
        }
      });
      if (rapporti.length === 0) {
        self.messaggiFctr.addMessage({
          type: 'E',
          message: 'Nessun rapporto selezionato'
        });
        self.spinner.cashflow = false;
        return;
      }
      service
        .promiseGetCashflow(rapporti, self.startDate, self.endDate)
        .then(function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.cashflow = false;
            return;
          }
          self.dataTable = response.data.result;
          self.dataTable.forEach(function (item) {
            if (!item.codiceMovimento) {
              item.codiceMovimento = 'CED';
            }
          });
          self.loadTable();
        })
        .finally(function () {
          self.spinner.cashflow = false;
        });
    };

    this.loadTable = function () {
      self.gridTable = self.tableService.getTable(
        self.dataTable,
        self.filterBox
      );
    };

    this.reloadRapporti = function () {
      var tmpRapporto = self.selectRapporti.concat([]);
      self.selectRapporti = [];
      self.selectNdg.forEach(function (ndg) {
        if (ndg.selected) {
          self.ndgs
            .find(function (n) {
              return n.ndg === ndg.ndg;
            })
            .rapporti.forEach(function (rapp) {
              var indexFind = self.selectRapporti.findIndex(function (rp) {
                return rp.rapporto === rapp.rapporto;
              });
              if (indexFind !== -1) {
                // Già censito
                self.selectRapporti[indexFind].intestazione =
                  ndg.ndg + '/' + self.selectRapporti[indexFind].intestazione;
              } else {
                var item = tmpRapporto.find(function (rp) {
                  return rp.rapporto === rapp.rapporto;
                });
                // Inserisco
                self.selectRapporti.push({
                  rapporto: rapp.rapporto,
                  intestazione: ndg.ndg + ' - Rapporto ' + rapp.rapporto,
                  selected: !!item ? item.selected : false
                });
                var dtStipula = new Date(rapp.dataStipula);
                self.minDate =
                  dtStipula.getTime() < self.minDate.getTime()
                    ? dtStipula
                    : self.minDate;
              }
            });
        }
      });
    };

    this.getExcel = function () {
      self.spinner.cashflow = true;
      this.tableService
        .excel(self.dataTable, self.filterBox)
        .then(function () {})
        .finally(function () {
          self.spinner.cashflow = false;
        });
    };

    this.indietro = function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (deskSrvc.isDesk) {
        deskSrvc.popEntry();
      }
      $state.go('home.schedaDossierDiv', {
        ndg: $stateParams.ndg,
        finCodiceRapporto: $stateParams.finCodiceRapporto,
        finDivisa: $stateParams.finDivisa,
        finCambio: $stateParams.finCambio,
        finDecimali: $stateParams.finDecimali
      });
    };
    $scope.loadEstrattoConto = function(){
     var dataInizioPerConfronto = new Date($scope.service.inputFormMovimenti.dataInizio)
         .toDateString()
         .substring(0,15);
     var dataMinimaPerConfronto = new Date(self.dataMinima)
          .toDateString()
          .substring(0,15); 
     var dataFinePerConfronto = new Date($scope.service.inputFormMovimenti.dataFine)
          .toDateString()
          .substring(0,15);
      $scope.spinner.reportMinus = true;  
      $scope.startDateRequired = 
      isNaN( Date.parse($scope.service.inputFormMovimenti.dataInizio)) 
      || Date.parse(dataInizioPerConfronto) < Date.parse(dataMinimaPerConfronto)
      || Date.parse($scope.service.inputFormMovimenti.dataInizio) > Date.parse($scope.service.inputFormMovimenti.dataFine)
      $scope.endDateRequired = 
      isNaN(Date.parse($scope.service.inputFormMovimenti.dataFine))
        || Date.parse(dataFinePerConfronto) < Date.parse(dataMinimaPerConfronto)
        || Date.parse($scope.service.inputFormMovimenti.dataFine) < Date.parse($scope.service.inputFormMovimenti.dataInizio)  
      ;

      if($scope.startDateRequired || $scope.endDateRequired){
        $scope.spinner.reportMinus = false;
        return;
      }
      service.promiseGetEstrattoConto(
        $stateParams.ndg,
        $stateParams.finCodiceRapporto,
        $scope.service.inputFormMovimenti.dataInizio.toISOString()
        .substring(0, 10),
        $scope.service.inputFormMovimenti.dataFine.toISOString()
        .substring(0, 10),
        $scope.service.filtriEstrattoContoFiscale
        )
      .then(
        function(response){
        if(messaggiFctr.processaResponse(response)){
          $scope.spinner.reportMinus = false;
          return;
        }
        $scope.spinner.reportMinus = false;
        self.collapseState=[];
        $scope.estrattoContoFiscale = response.data.result;
        $scope.tabellaEstrattoConto.eventi = $scope.estrattoContoFiscale.eventi
          .map(function(evento){
            evento.eventoConto.forEach(function(detail){
              detail.evento = detail.evento.trim();
              $scope.service.filtriEstrattoContoFiscale.espandiTutto ? self.collapseState.push(true) : self.collapseState.push(false);
              return detail.evento;  
            })
            return evento;
          });
          setTimeout(self.collapseAll,500);
      }).finally(function(){
        $scope.spinner.reportMinus = false;
      });
    }
    $scope.exportEstrattoConto = function(){
      $scope.spinner.exportXls = true;
      var xlsString = $scope.estrattoContoFiscale.xlxs;
      tableService.download(xlsString,'estrattoContoFiscale.xlxs');
      $scope.spinner.exportXls = false;    }

    $scope.openPlusMinusModal = function(item,descrizioneIntestatario){
      if(item.evento === 'PLUS'){
        /*
        aggiungo l'intestatario ad ogni oggetto plusMinus
        per averlo da mostrare nella modale
        */
        item.plusMinus.forEach(function(x){
          x.descrizioneIntestatario = descrizioneIntestatario;
        });
        $scope.plusMinusperModale = item;
        $('#modalePlus').modal('show');
      }else if(item.evento === 'MINUS'){
        /*
        aggiungo l'intestatario ad ogni oggetto plusMinus
        per averlo da mostrare nella modale
        */
        item.plusMinus.forEach(function(x){
          x.descrizioneIntestatario = descrizioneIntestatario;
        });
        $scope.plusMinusperModale = item;
        $('#modaleMinus').modal('show');
      }else{
        return;
      }
     }
     this.filtraEstrattoConto = function(){
      $scope.tabellaEstrattoConto.eventi.forEach(function(evento){
        if($scope.service.filtriEstrattoContoFiscale.plusMinus === false){
          evento.eventoConto = evento.eventoConto.filter(function(detail){
            return detail.evento !== 'PLUS'
          })
          evento.eventoConto = evento.eventoConto.filter(function(detail){
            return detail.evento !== 'MINUS'
          })
        }
        if($scope.service.filtriEstrattoContoFiscale.venditaScaricoPrelievo === false){
          evento.eventoConto = evento.eventoConto.filter(function(detail){
            return detail.evento !== 'SCARICO'
          })
          evento.eventoConto = evento.eventoConto.filter(function(detail){
            return detail.evento !== 'VENDITA'
          })
          evento.eventoConto = evento.eventoConto.filter(function(detail){
            return detail.evento !== 'PRELIEVO'
          })
        }
        if($scope.service.filtriEstrattoContoFiscale.acquistoCaricoConf === false){
          evento.eventoConto = evento.eventoConto.filter(function(detail){
            return detail.evento !== 'ACQUISTO'
          })
          evento.eventoConto = evento.eventoConto.filter(function(detail){
            return detail.evento !== 'CARICO'
          })
          evento.eventoConto = evento.eventoConto.filter(function(detail){
            return detail.evento !== 'CONFERIM'
          })
        }
        if($scope.service.filtriEstrattoContoFiscale.salIniz === false){
          evento.eventoConto = evento.eventoConto.filter(function(detail){
            return detail.evento !== 'SAL.INIZ'
          })
        }
        if($scope.service.filtriEstrattoContoFiscale.salFin === false){
          return detail.evento !== 'SAL.FIN'
        }
      })
    };
    $scope.returnExpandAll = function(){
      return $scope.service.filtriEstrattoContoFiscale.espandiTutto;
    }
    $scope.resetButtons = function(){{
      $scope.service.filtriEstrattoContoFiscale = {
        salIniz:true,
        salFin:true,
        plusMinus:true,
        venditaScaricoPrelievo:false,
        acquistoCaricoConf:false,
        espandiTutto: true
    }
    }}
    this.collapsePanelDetail = function(number){
      $('#myDetail_'+number).collapse('toggle') 
      self.collapseState[number] = !self.collapseState[number];
    };
    this.collapseAll = function(){
      if($scope.service.filtriEstrattoContoFiscale.espandiTutto){
        $scope.estrattoContoFiscale.eventi.forEach(function(state,index){
              $('#myDetail_'+index).collapse('show')
        })    
      }else{
        $scope.estrattoContoFiscale.eventi.forEach(function(state,index){
            $('#myDetail_'+index).collapse('hide');
        });
      }
      
    }
  };

  EstrattoContoCtrl.$inject = [
    '$http',
    '$scope',
    '$window',
    '$q',
    '$stateParams',
    '$state',
    '$location',
    'FIN_CONSTANTS',
    'FinLabelSrvc',
    'FinMessaggiFctr',
    'uiGridConstants',
    'CblMessageSrvc',
    'FinUserSrvc',
    '$uibModal',
    'FinBrioSrvc',
    'EstrattoContoSrvc',
    'EstrattoContoTableSrvc',
    'FinDeskSrvc',
    'FinUploadSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'estrattoConto/estrattoConto.html'
    );
  };
  TemplateUrl.$inject = ['FIN_CONSTANTS'];

  var CashflowComponent = {
    bindings: {},
    controller: EstrattoContoCtrl,
    controllerAs: 'cashflowCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.finanza.mf')
    .component('finanzaEstrattoConto', CashflowComponent);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/estrattoconto/estrattoconto.cmpt.js
 ** module id = 53
 ** module chunks = 1
 **/